import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Esports() {
    const navigate = useNavigate();

    // Khai báo các State cần thiết
    const [isLoading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);

    // Hàm chạy ngầm rút tiền nếu phiên trước người dùng tắt trình duyệt ngang xương
    const autoRecoverMoney = (productType) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: productType })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: productType,
                        type: 2,
                        money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => {
                // Rút tiền cũ thành công thì xóa flag kẹt tiền
                localStorage.removeItem("playing_product");
                // Tải lại thông tin ví tổng mới cho user
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => {
                console.log("Lỗi tự động thu hồi tiền phiên cũ:", err);
            });
    };

    // Cấu hình Axios Interceptor và Load dữ liệu ban đầu
    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Lấy thông tin User khi vào trang
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));

                // Kiểm tra kẹt tiền phiên cũ
                const interruptedProduct = localStorage.getItem("playing_product");
                if (interruptedProduct) {
                    autoRecoverMoney(interruptedProduct);
                }
            })
            .catch((err) => {
                localStorage.removeItem("user");
                // navigate("/login");
            });

        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, []);

    // Lắng nghe sự kiện bấm nút Quay lại (Back) của điện thoại
    useEffect(() => {
        const handlePopState = (event) => {
            if (playGame) {
                // Kích hoạt tiến trình đóng game và tự rút tiền ngầm giống hệt nút Thoát
                handleCloseGame();
            }
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [playGame, product]);

    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // HÀM KHỞI CHẠY GAME VÀ TỰ ĐỘNG NẠP TIỀN
    function launchGame(params) {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") == "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading === true) return;

        const form = {
            ...params,
            platform: isMobileDevice() === true ? "html5" : "html5-desktop"
        };

        setLoading(true);

        let a;
        switch (params.product_type) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "98": a = "PG"; break;
            case "99": a = "TF"; break;
            case "3": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            case "61": a = "IMES"; break;
            case "132": a = "SV388"; break;
            default: a = ""; break;
        }
        setSanh(a);
        setProduct(params.product_type);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status === 0) {
                    const gameUrl = res.data.data.game_url;

                    if (profile && profile.money > 0) {
                        const amountToTransfer = Math.floor(profile.money);
                        const autoTransferData = {
                            product_type: params.product_type,
                            type: 1, 
                            money: amountToTransfer
                        };

                        axios
                            .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoTransferData)
                            .then(() => {
                                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((userRes) => {
                                    setProfile(userRes.data.data);
                                    localStorage.setItem("profile", JSON.stringify(userRes.data.data));

                                    // Đánh dấu cache: Đang chơi sảnh này đề phòng sập nguồn/tắt tab
                                    localStorage.setItem("playing_product", params.product_type);

                                    // Tạo lịch sử ảo để chặn/bắt sự kiện nút Back trên điện thoại
                                    window.history.pushState({ inGame: true }, "");

                                    setPlayGame(gameUrl);
                                    setLoading(false);
                                });
                            })
                            .catch((err) => {
                                setLoading(false);
                                swal("Lỗi tự động chuyển quỹ", "Không thể tự động nạp tiền vào sảnh game, vui lòng thử lại.", "error");
                            });
                    } else {
                        localStorage.setItem("playing_product", params.product_type);
                        window.history.pushState({ inGame: true }, "");
                        setPlayGame(gameUrl);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    }

    // HÀM ĐÓNG TRÒ CHƠI VÀ TỰ ĐỘNG THU HỒI SỐ DƯ
    const handleCloseGame = () => {
        setLoading(true);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    const autoWithdrawData = {
                        product_type: product,
                        type: 2, 
                        money: Math.floor(currentBalance)
                    };
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoWithdrawData);
                }
                return Promise.resolve();
            })
            .then(() => {
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                // Thoát an toàn hoàn tất -> Xóa flag cache chơi game
                localStorage.removeItem("playing_product");
                setPlayGame(null); 
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setPlayGame(null); 
                swal("Thông báo", "Hệ thống đang xử lý lệnh kết toán muộn. Vui lòng kiểm tra lại số dư ví tổng sau ít phút.", "warning");
            });
    };

    return (
        <>
            <Header profile={profile} />
            
            {isLoading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            <div className="bg-esports">
                <div className="esports">
                    <div className="games-wrap">
                        <div className="gl">
                            <img src={require("../../statics/gl.png")} alt="GL" />
                        </div>
                        <div className="games">
                            <div className="play" onClick={() => launchGame({ product_type: "61", game_code: "IMES17" })} style={{ cursor: "pointer" }}>
                                <img src={require("../../statics/im_esports.png")} alt="IM Esports" />
                                <div className="play-btn"></div>
                            </div>
                            <div className="play" onClick={() => launchGame({ product_type: "99", game_code: "TF0001" })} style={{ cursor: "pointer" }}>
                                <img src={require("../../statics/tf.png")} alt="TF Esports" />
                                <div className="play-btn"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* IFRAME HIỂN THỊ GAME KÈM THANH TOP BAR THEO CHUẨN */}
            {playGame ? (
                <div 
                    className="iframe-game-backdrop" 
                    style={{ 
                        position: "fixed", 
                        top: 0, 
                        left: 0, 
                        width: "100vw", 
                        height: "100vh", 
                        backgroundColor: "#000", 
                        zIndex: 99999,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <div style={{
                        width: "100%",
                        height: "50px",
                        backgroundColor: "#162a35", 
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 15px",
                        boxSizing: "border-box"
                    }}>
                        <div style={{ 
                            color: "#ffcc00", 
                            fontWeight: "bold", 
                            fontSize: "18px",
                            fontFamily: "sans-serif"
                        }}>
                            {sanh}
                        </div>
                        <button 
                            onClick={handleCloseGame} 
                            style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center",
                                gap: "4px",
                                backgroundColor: "#ff5050", 
                                color: "#fff", 
                                border: "none",
                                borderRadius: "20px", 
                                padding: "6px 16px",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                        </button>
                    </div>
                    
                    <iframe 
                        src={playGame} 
                        title={`Sảnh ${sanh}`}
                        style={{ 
                            width: "100%", 
                            flexGrow: 1, 
                            border: "none" 
                        }} 
                        allowFullScreen
                    ></iframe>
                </div>
            ) : null}
        </>
    );
}

export default Esports;